module.exports = __webpack_public_path__ + "img/1.d100cb24.jpg";